import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, OTO_LINK } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const UsedLinks = () => {
	const columns = useMemo(
		() => [
			{
				field: 'linkSessionId',
				Header: 'linkSessionId',
				accessor: 'linkSessionId',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				field: 'orderId',
				Header: 'orderId',
				accessor: 'orderNumber',
				filterType: FilterType.string
			},
			{
				field: 'buyerName',
				Header: 'buyerName',
				accessor: 'buyerName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				field: 'buyerAddress',
				Header: 'buyerAddress',
				accessor: 'address',
				filterType: FilterType.string
			},
			{
				field: 'shippingMethod',
				Header: 'shippingMethod',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				renderCell: ListComponents.DC_LOGO
			},
			{
				field: 'paymentMethod',
				Header: 'paymentMethod',
				accessor: 'selectedPaymentMethod',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PAYMENT_METHOD_FOR_LIST
			},
			{
				field: 'status',
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.OTO_LINK_SESSION_STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.OTOLINK_STATUSES,
				showOnMobile: true
			},
			{
				field: 'lastTimeUsed',
				Header: 'lastTimeUsed',
				accessor: 'lastUsedDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<DynamicList
			id={DYNAMICLISTS.OTOLINK_USED}
			columns={columns}
			fetchUrl={OTO_LINK.GET_USED_OTO_LINKS}
			defaultSort={[{ id: 'linkSessionId', desc: true }]}
			actionObjectType={ACTION_OBJECT_TYPES.OTHER}
		/>
	);
};

export default UsedLinks;
